module.exports = __webpack_public_path__ + "static/img/probanner.6722fe9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/probanner.jpg
// module id = 79
// module chunks = 2